<template>
  <div class="sidebar-page-wrapper">
    <div
      class="sidebar-menu-bg"
      v-if="menuBg && $root.screenWidth > 550"
      :style="{ 'background-image': `url(${menuBg})` }"
    ></div>
    <div
      class="sidebar"
      :style="{
        'background-image': $root.screenWidth <= 550 ? `url(${menuBg})` : ''
      }"
    >
      <el-menu
        router
        :default-active="$route.path"
        class="sidebar-menu manage-sidebar-menu"
        :mode="$root.screenWidth > 550 ? 'vertical' : 'horizontal'"
        v-if="
          p('Report.Trial Reports.Generate.View') ||
            p('Report.Trial Reports.History.View')
        "
      >
        <el-submenu index="/reports/generate">
          <template slot="title">
            <span>{{ $t('text.trial_reports') }}</span>
          </template>
          <el-menu-item
            index="/reports/generate"
            v-if="p('Report.Trial Reports.Generate.View')"
          >
            <span slot="title">{{ $t('text.generate') }}</span>
          </el-menu-item>
          <el-menu-item
            index="/reports/history"
            v-if="p('Report.Trial Reports.History.View')"
          >
            <span slot="title">{{ $t('text.history') }}</span>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
    <div class="sidebar-type-page-content">
      <Helper v-if="$route.path !== '/manage/landing'" />
      <router-view ref="content" />
    </div>
  </div>
</template>

<script>
import Helper from '@/components/Helper.vue'
export default {
  components: {
    Helper
  },
  computed: {
    menuBg() {
      return this.$store.state.customization.menuBg
    }
  }
}
</script>
